import { useQuery, useQueryClient } from '@tanstack/react-query';
import objetivosApi from '../api/objetivos';

export const objetivosQueryKeys = {
  all: ['objetivos'],
  list: (brandId) => ['objetivos', brandId != null ? String(brandId) : ''],
};

export async function fetchObjetivosForBrand(brandId) {
  const res = await objetivosApi.getObjetivos(brandId);
  const data = res?.data?.objetivos ?? res?.data ?? res ?? [];
  return Array.isArray(data) ? data : [];
}

const STALE_MS = 2 * 60 * 1000;

export function useObjetivosQuery(brandId, options = {}) {
  const id = brandId != null && brandId !== '' ? String(brandId) : null;
  return useQuery({
    queryKey: objetivosQueryKeys.list(id),
    queryFn: () => fetchObjetivosForBrand(id),
    enabled: Boolean(id),
    staleTime: STALE_MS,
    ...options,
  });
}

export function invalidateObjetivosQueries(queryClient, brandId) {
  if (brandId != null && brandId !== '') {
    queryClient.invalidateQueries({ queryKey: objetivosQueryKeys.list(String(brandId)) });
  } else {
    queryClient.invalidateQueries({ queryKey: objetivosQueryKeys.all });
  }
}

/** Hook to invalidate objetivos cache (e.g. after window event). */
export function useInvalidateObjetivos() {
  const qc = useQueryClient();
  return (brandId) => invalidateObjetivosQueries(qc, brandId);
}
